/* global axios */
import ApiClient from './ApiClient';

class GlossaryAPI extends ApiClient {
  constructor() {
    super('glossaries', { accountScoped: true });
  }

  resync(id) {
    return axios.post(`${this.url}/${id}/resync`);
  }

  createTerm(id, data) {
    return axios.post(`${this.url}/${id}/terms`, data);
  }

  updateTerm(id, index, data) {
    return axios.patch(`${this.url}/${id}/terms/${index}`, data);
  }

  deleteTerm(id, index) {
    return axios.delete(`${this.url}/${id}/terms/${index}`);
  }
}

export default new GlossaryAPI();
